export enum RequiredReferenceCount {
  ONE = 'ONE',
  GREATER_THAN_ONE = 'GREATER_THAN_ONE',
  ONE_OR_MORE = 'ONE_OR_MORE',
}
